import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql, Link } from 'gatsby';
import Img from 'gatsby-image';

import { media, TransitionMixin } from '../../helpers';
import Wrapper from '../../elements/wrapper';

import Circles from '../../../images/icons/hover-circles.inline.svg';

const HomeCollectionCardContainer = styled.div`
    padding-top: 7.5vh;
    .title-container {
        padding-bottom: 3vh;
        h3 {
            font-size: 2.2rem;
            text-align: center;
            color: #000;
            margin: 0;
            font-weight: 800;
            font-family: neue-kabel, sans-serif;
            ${media.large`font-size: 2.4rem; text-align: left;`}
        }
    }

    .card-grid-container {
        position: relative;
        bottom: -10vh;
        margin-top: -10vh;
        ${media.small`display: flex; flex-wrap: wrap; `}
        ${media.medium`max-width: 84.4vw; justify-content: center; margin-bottom: -40px;`}

        .item-container {
            flex: 0 0 50%;
            margin-bottom: 40px;
            ${media.medium`flex: 0 0 33.33%;`}
            > .inner-wrap {
                max-width: 95%;
                margin: 0 auto;

                a {
                    text-decoration: none;
                    &:hover {
                        .image-container {
                            .overlay {
                                opacity: 1;
                            }
                            .content-container {
                                h4 {
                                    text-shadow: none;
                                }

                                p {
                                    text-shadow: none;
                                }
                            }
                        }
                    }
                }
                .image-container {
                    position: relative;
                    .content-container {
                        position: absolute;
                        top: 45%;
                        left: 2vw;

                        h4 {
                            color: #fff;
                            font-size: 1.7rem;
                            margin: 0 0 5px;
                            font-weight: 800;
                            font-family: neue-kabel, sans-serif;
                            text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
                        }

                        p {
                            color: #fff;
                            margin: 0;
                            font-size: 1.1rem;
                            font-weight: 900;
                            text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
                        }
                    }

                    .overlay {
                        background-color: #000;
                        position: absolute;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                        ${TransitionMixin('.25s')};

                        svg {
                            position: absolute;
                            bottom: 0;
                            z-index: 100;
                            width: 100%;
                            height: auto;

                            g {
                                mask: none;
                            }
                        }
                    }
                }
            }
        }
    }
`;

const HomeCollectionCard = () => {
    const data = useStaticQuery(graphql`
        query {
            home: allWpPage(filter: { title: { eq: "Home" } }) {
                edges {
                    node {
                        id
                        home_acf {
                            collectionCardsSectionTitle
                            collectionCards {
                                cardLink {
                                    title
                                    url
                                }
                                cardImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 600, quality: 90) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                overlayColor
                            }
                        }
                    }
                }
            }
        }
    `);
    const { collectionCardsSectionTitle, collectionCards } =
        data.home.edges[0].node.home_acf || {};
    return (
        <HomeCollectionCardContainer>
            <Wrapper className="title-container line-up">
                <h3>{collectionCardsSectionTitle}</h3>
            </Wrapper>
            <Wrapper className="card-grid-container line-up">
                {collectionCards &&
                    collectionCards.map((card, index) => {
                        const { cardLink, cardImage, overlayColor } =
                            card || {};

                        return (
                            <div className="item-container" key={index}>
                                <div className="inner-wrap">
                                    {cardImage && (
                                        <Link to={cardLink.url}>
                                            <div className="image-container">
                                                <Img
                                                    fluid={
                                                        cardImage.localFile
                                                            .childImageSharp
                                                            .fluid
                                                    }
                                                />
                                                <div
                                                    className="overlay"
                                                    style={{
                                                        backgroundColor: overlayColor,
                                                    }}
                                                >
                                                    <Circles />
                                                </div>
                                                <div className="content-container">
                                                    <div className="inner-wrap">
                                                        <h4>
                                                            {cardLink.title}
                                                        </h4>
                                                        <p>Shop now</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        );
                    })}
            </Wrapper>
        </HomeCollectionCardContainer>
    );
};

export default HomeCollectionCard;
